<template>
  <div class="halloween">
    <!-- 头部 -->
    <v-header></v-header>
    <!-- 内容 -->
    <div class="halloween-c">
      <!-- banner -->
      <div class="h-banner">
        <img
          src="../assets/images/halloween_banner_bg.png"
          :alt="this.$t('message.wstag')"
        />
        <div class="h-bf">
          <h1>{{ $t("message.halloweenweb.h1") }}</h1>
          <h3>{{ $t("message.halloweenweb.h2") }}</h3>
          <el-button type="primary">
            <template v-if="this.$i18n.locale === 'zh'">
              <router-link
                :to="{ path: '/menu/', params: { lang: this.$i18n.locale } }"
                >{{ $t("message.halloweenweb.btn") }}</router-link
              >
            </template>
            <template v-else>
              <router-link
                :to="{ path: '/enmenu/', params: { lang: this.$i18n.locale } }"
                >{{ $t("message.halloweenweb.btn") }}</router-link
              >
            </template>
          </el-button>
        </div>
      </div>
      <!-- 气氛 -->
      <div class="qf f">
        <div class="qf-top">
          <div>
            <h2>{{ $t("message.halloweenweb.section1h2") }}</h2>
          </div>
        </div>
        <div class="qf-bottom">
          <div>
            <div>
              <img src="../assets/images/halloween1_img.png" alt />
            </div>
            <div>
              <p>{{ $t("message.halloweenweb.section1p") }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 必选 -->
      <div class="bx">
        <div class="bx-top">
          <div>
            <h2>{{ $t("message.halloweenweb.section2h2") }}</h2>
          </div>
        </div>
        <div class="bx-bottom">
          <div>
            <div>
              <div>
                <img src="../assets/images/halloween2_img1.png" alt />
              </div>
              <div>
                <h3>{{ $t("message.halloweenweb.section2h3_1") }}</h3>
                <p>{{ $t("message.halloweenweb.section2p1") }}</p>
              </div>
            </div>
            <div>
              <div>
                <img src="../assets/images/halloween2_img2.png" alt />
              </div>
              <div>
                <h3>{{ $t("message.halloweenweb.section2h3_2") }}</h3>
                <p>{{ $t("message.halloweenweb.section2p2") }}</p>
              </div>
            </div>
            <div>
              <div>
                <img src="../assets/images/halloween2_img3.png" alt />
              </div>
              <div>
                <h3>{{ $t("message.halloweenweb.section2h3_3") }}</h3>
                <p>{{ $t("message.halloweenweb.section2p3") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 联系 -->
      <div class="h-call">
        <div class="hcall-top">
          <div>
            <h2>{{ $t("message.halloweenweb.section3h2") }}</h2>
          </div>
        </div>
        <div class="hcall-bottom">
          <p>{{ $t("message.halloweenweb.section3p") }}</p>
          <!-- <p>{{ $t("message.halloweenweb.tip") }}</p> -->
          <el-button class="goca">
            <a
              style="text-decoration: none"
              href="https://api.whatsapp.com/send?phone=85264586539&text=hello%20%E5%88%B0%E6%9C%83%E5%AE%B6,%E6%88%91%E6%83%B3%E8%A8%82%E5%88%B0%E6%9C%83%EF%BC%81%F0%9F%98%8B%F0%9F%98%8B"
              target="_black"
            ></a>
          </el-button>
        </div>
      </div>
    </div>
    <!-- 尾部 -->
  </div>
</template>

<script>
import header from "../components/header";
export default {
  name: "halloween",
  data() {
    return {};
  },
  components: {
    "v-header": header,
  }
};
</script>

<style scoped>
.halloween {
  background: url("../assets/images/halloween_bg.png");
}
.halloween .halloween-c {
  margin: 110px 0 0 0;
}
.halloween .h-banner {
  position: relative;
  display: flex;
  align-items: center;
}
.halloween .h-banner img {
  height: 100%;
  width: 100%;
}
.halloween .h-banner .h-bf {
  position: absolute;
  width: 100%;
  margin: auto;
  border-radius: 5px;
  padding: 5% 0;
  text-align: center;
  color: #fff;
}
.halloween .h-banner .h-bf button {
  font-weight: 600;
  color: black;
  text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white;
  font-size: 20px;
  width: 200px;
  height: 70px;
  background: url("../assets/images/banner_btn.gif");
  background-size: 100% 100%;
  border: none;
}
.halloween .h-banner .h-bf button a {
  display: block;
  color: #000;
  text-decoration: none;
}
.halloween .h-banner .h-bf h1 {
  margin: auto;
  width: 50%;
  letter-spacing: 8px;
  color: #fc8817;
  font-size: 4vw;
  text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white;
}
.halloween .h-banner .h-bf h3 {
  width: 50%;
  font-size: 2vw;
  font-weight: 400;
  letter-spacing: 8px;
  margin: 3% auto;
}
.halloween .qf,
.halloween .bx,
.halloween .h-call {
  width: 70%;
  margin: 6% auto;
}
.halloween .qf .qf-top > div,
.halloween .bx .bx-top > div,
.halloween .h-call .hcall-top > div {
  margin: auto;
  height: 110px;
  background-image: url("../assets/images/halloween_title_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
}
.halloween .qf .qf-top > div {
  font-size: 0.82vw;
}
.halloween .bx .bx-top > div {
  font-size: 0.68vw;
}
.halloween .h-call .hcall-top > div {
  font-size: 0.8vw;
}
.halloween .qf .qf-top > div,
.halloween .bx .bx-top > div {
  width: 450px;
}
.halloween .h-call .hcall-top > div {
  width: 450px;
}
.halloween .qf .qf-top > div h2,
.halloween .bx .bx-top > div h2,
.halloween .h-call .hcall-top > div h2 {
  position: absolute;
  left: 27%;
  top: 41px;
  transform: rotate(-2deg);
}
.halloween .qf-bottom {
  margin: 5% 0;
  background-image: url("../assets/images/halloween3_bg.png");
  background-size: 100% 100%;
}
.halloween .bx-bottom {
  margin: 5% 0;
}
.halloween .qf-bottom > div,
.halloween .bx-bottom > div {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.halloween .qf-bottom > div > div {
  flex: 0 0 50%;
  padding: 20px;
  box-sizing: border-box;
}
.halloween .qf-bottom > div > div:nth-child(2) {
  padding: 20px 30px 20px 0px;
}
.halloween .qf-bottom > div > div:nth-child(2) p {
  color: #fff;
  line-height: 30px;
}
.halloween .qf-bottom > div > div:nth-child(1) img {
  width: 100%;
  height: 100%;
}
.halloween .bx-bottom > div > div {
  flex: 0 0 32%;
  background: #fc8817;
  padding: 10px 10px 20px 10px;
  box-sizing: border-box;
  text-align: center;
  color: #fff;
}
.halloween .bx-bottom img {
  width: 100%;
  height: 100%;
}
.halloween .bx-bottom h3 {
  /* font-family: FZCYJ; */
  margin: 10px 0;
}
.halloween .bx-bottom p {
  width: 80%;
  font-size: 14px;
  margin: auto;
}
.halloween .hcall-bottom {
  margin: 5% 0 0 0;
  padding: 20px 50px;
  background: url("../assets/images/halloween3_bg.png");
  background-size: 100% 100%;
  text-align: center;
}
.halloween .hcall-bottom > p:nth-child(1) {
  color: #fff;
  font-size: 15px;
  margin: 30px 0;
}
.halloween .hcall-bottom > p:nth-child(2) {
  width: 30%;
  margin: 0 auto 3% auto;
  padding: 10px;
}
.halloween .hcall-bottom button {
  background: url("../assets/images/halloween3_btn.png");
  background-size: 100% 100%;
  width: 235px;
  height: 60px;
  border: none;
  margin: 0 0 20px 0;
}
.halloween .goca span,
.halloween .goca a {
  display: block;
  height: 100%;
}
.halloween .qf.f > .qf-bottom > div {
  align-items: center;
}
/* 移动端 */
@media (max-width: 1600px) {
  .halloween .qf .qf-top > div {
    font-size: 1vw;
  }
  .halloween .bx .bx-top > div {
    font-size: 0.8vw;
  }
  .halloween .h-call .hcall-top > div {
    font-size: 0.91vw;
  }
}
@media (max-width: 1450px) {
  .halloween .qf .qf-top > div {
    font-size: 1vw;
  }
  .halloween .bx .bx-top > div {
    font-size: 0.9vw;
  }
  .halloween .h-call .hcall-top > div {
    font-size: 1vw;
  }
}
@media (max-width: 1250px) {
  .halloween .qf .qf-top > div {
    font-size: 1.2vw;
  }
  .halloween .bx .bx-top > div {
    font-size: 1vw;
  }
  .halloween .h-call .hcall-top > div {
    font-size: 1.2vw;
  }
}
@media (max-width: 1200px) {
  .halloween .qf .qf-top > div {
    font-size: 1.3vw;
  }
  .halloween .h-call .hcall-top > div {
    font-size: 1.22vw;
  }
}
@media (max-width: 1050px) {
  .halloween .qf .qf-top > div {
    font-size: 1.5vw;
  }
  .halloween .bx .bx-top > div {
    font-size: 1.2vw;
  }
  .halloween .h-call .hcall-top > div {
    font-size: 1.35vw;
  }
  .halloween .h-banner .h-bf h1 {
    font-size: 5vw;
  }
  .halloween .h-banner .h-bf h3 {
    font-size: 2.3vw;
    letter-spacing: 4px;
  }
  .halloween .hcall-bottom > p:nth-child(2) {
    width: 50%;
  }
}
@media (max-width: 1000px) {
  .halloween .qf .qf-top > div {
    font-size: 1.5vw;
  }
  .halloween .bx .bx-top > div {
    font-size: 1.3vw;
  }
  .halloween .h-call .hcall-top > div {
    font-size: 1.5vw;
  }
}
@media (max-width: 860px) {
  .halloween .qf .qf-top > div {
    font-size: 1.8vw;
  }
  .halloween .bx .bx-top > div {
    font-size: 1.5vw;
  }
  .halloween .h-call .hcall-top > div {
    font-size: 1.7vw;
  }
}
@media screen and (min-width: 480px) and (max-width: 768px) {
  .halloween .h-banner .h-bf h1 {
    font-size: 4vw;
    letter-spacing: 4px;
  }
  .halloween .h-banner .h-bf h3 {
    font-size: 2.5vw;
    letter-spacing: 2px;
  }
  .halloween .qf,
  .halloween .bx,
  .halloween .h-call {
    width: 90%;
  }
  .halloween .h-banner .h-bf h1,
  .halloween .h-banner .h-bf h3 {
    width: 80%;
    letter-spacing: 5px;
    margin-bottom: 5px;
  }
  .halloween .qf .qf-top > div {
    font-size: 2.1vw;
  }
  .halloween .bx .bx-top > div {
    font-size: 1.7vw;
  }
  .halloween .h-call .hcall-top > div {
    font-size: 15px;
  }
}
@media (max-width: 480px) {
  .halloween .h-banner .h-bf button {
    font-size: 16px;
    height: 50px;
  }
  .halloween .h-banner .h-bf h1,
  .halloween .h-banner .h-bf h3 {
    width: 95%;
    font-size: 5vw;
    letter-spacing: 4px;
    margin-bottom: 5px;
  }
  .halloween .hcall-bottom button {
    width: 200px;
    height: 47px;
  }
  .halloween .h-banner .h-bf {
    width: 100%;
    margin-top: 135px;
  }
  .halloween .h-banner .h-bf h3 {
    font-size: 14px;
    letter-spacing: 4px;
  }
  .halloween .qf,
  .halloween .bx,
  .halloween .h-call {
    width: 90%;
    margin: 15% auto;
  }
  .halloween .qf .qf-top > div,
  .halloween .bx .bx-top > div,
  .halloween .h-call .hcall-top > div {
    width: 100%;
  }
  .halloween .qf .qf-top > div h2,
  .halloween .bx .bx-top > div h2,
  .halloween .h-call .hcall-top > div h2 {
    top: 43px;
  }
  .halloween .qf-bottom > div > div {
    flex: 0 0 100%;
  }
  .halloween .qf-bottom > div > div {
    padding-top: 23px;
  }
  .halloween .qf-bottom > div > div:nth-child(2) {
    padding: 0px 15px 20px 15px;
  }
  .halloween .qf-bottom > div > div:nth-child(2) p {
    font-size: 15px;
  }
  .halloween .bx-bottom > div > div {
    flex: 0 0 100%;
    margin-bottom: 20px;
  }
  .halloween .hcall-bottom {
    padding: 20px 20px;
  }
  .halloween .hcall-bottom > p:nth-child(2) {
    width: 90%;
  }
  .halloween .qf .qf-top > div {
    font-size: 2.8vw;
  }
  .halloween .bx .bx-top > div {
    font-size: 2.2vw;
  }
  .halloween .h-call .hcall-top > div {
    font-size: 2.7vw;
  }
}
</style>
